export default __webpack_public_path__ + "static/media/curved-arrow-right.dd81a49c.svg";